import React from "react";
import { IPerson } from "../../../interfaces";
import type { IPhoneNumber } from "../../../components/staff/PhoneNumber";
import { formatPhoneForDisplay } from "../../../utils/formatPhoneForDisplay";
import Phone from "../../../components/Atomos/Icons/ViewMode/Phone";
import Email from "../../../components/Atomos/Icons/Email";
import ProfilePhoto from "../../../components/Atomos/ProfilePhoto";
import { resolveProfilePictureDisplayUrl } from "../../../utils/profilePictureUrl";

interface ShortPersonCardProps {
  person: IPerson;
}
const ContactFrame: React.FC<ShortPersonCardProps> = ({ person }) => {
  const photoSrc = person?.id
    ? resolveProfilePictureDisplayUrl(person.id, person.photo, {
        photoUpdatedAt: person._ts,
      })
    : "";

  return (
    <React.Fragment>
      <div className="flex items-center gap-6 lg:gap-[.625rem] lg:flex-1 self-stretch">
        <div className="flex lg:flex-col lg:items-center lg:gap-1">
          <div className="flex flex-col items-center gap-[0.625rem]">
            <div className="flex h-[5.5rem] w-[5.5rem] items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-gray-100">
              <ProfilePhoto src={photoSrc} />
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center gap-1 self-stretch">
          <span className="text-primary lg:text-xl lg:leading-7 font-bold self-stretch">
            {person.name ?? ""} {person.lastName ?? ""}
          </span>
          <span className="text-gray-font lg:text-[1.125rem] lg:leading-5 self-stretch ">
            {person.title ?? person.listTitle}
          </span>
          <div className="flex lg:items-start lg:gap-3 self-stretch">
            <span className="flex gap-1 h-5 text-gray-font lg:text-[1.125rem] lg:leading-5 self-stretch">
              <Phone />
              {formatPhoneForDisplay(
                person.phoneNumber as string | IPhoneNumber | undefined
              )}
            </span>
          </div>
          <div className="flex lg:items-start lg:gap-3 self-stretch">
            <span className="flex gap-1 h-5 text-gray-font lg:text-[1.125rem] lg:leading-5 self-stretch">
              <div className="fill-gray-font h-5 w-5">
                <Email />
              </div>
              {person.firmEmail}
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContactFrame;
